import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  AccountScorecards,
  IAccountScorecards,
} from '../../feature-modules/insights/pages/manage-scorecards/models/scorecard.model';
import { arrayOfType } from '../../shared/utils/data.utils';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ScorecardsService {
  constructor(private readonly httpClient: HttpClient) {}

  getScorecards(accountIds: number[]): Observable<IAccountScorecards[]> {
    return this.httpClient
      .post<IAccountScorecards[]>(`${environment.scorecards_api_url}/v1/scorecards/accounts`, { accountIds })
      .pipe(
        map((accountScorecards) =>
          arrayOfType<IAccountScorecards>(
            accountScorecards.filter(({ scorecards }) => scorecards.length),
            AccountScorecards,
          ),
        ),
      );
  }
}
